import './TypingLoader.scss';
import React from 'react';


export default function TypingLoader() {
  return (
    <div className="typing-loader">
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </div>
  )
}